import React, { useContext } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import UserContext from "../context/userContext";
import { formatCCF } from "../utils/CCFUtils";

//import Badge from "react-bootstrap/Badge";

const DataEntryTable = ({
  headings,
  parameterData,
  originalData,
  updateCCF,
  handleChange,
  startDate,
  endDate,
  showCodes,
  handleSubmit,
  fontSize
}) => {
  const [user] = useContext(UserContext);
  
  const refList = [];
  function getDataClass(header, data) {
    let dataClass = "text-center text-nowrap";

    //apply class for CCFs
    if (formatCCF(header, data, originalData)) dataClass += " table-warning";
    else {
      //apply class for parameter limits
      if (header.SEPERATOR) dataClass += " seperator";
      
      if (header.TYPE_ID === "SIM") dataClass += " table-calc";
      
      if (isNaN(data[header.CODE])) return dataClass;
      
      if (!data[header.CODE] && header.TYPE_ID !== "SIM") return dataClass + " bg-light";
      
      if (header.UPPER_CHECK !== null && data[header.CODE] > header.UPPER_CHECK) dataClass += " table-danger";
      else if (header.LOWER_CHECK !== null && data[header.CODE] < header.LOWER_CHECK) dataClass += " table-danger";
      
      if (header.UPPER_ABSOLUTE !== null && data[header.CODE] > header.UPPER_ABSOLUTE) dataClass += " table-danger-2";
      else if (header.LOWER_ABSOLUTE !== null && data[header.CODE] < header.LOWER_ABSOLUTE) dataClass += " table-danger-2";
    }
    
    return dataClass;
  }

  function getParameterClass(parameter) {
    var headingClass = "text-center text-nowrap";
    if (parameter.SEPERATOR) headingClass += " seperator";
    if (parameter.TYPE_ID === "SIM") headingClass += " calculated-header";
    if (parameter.TYPE_ID === "CON") headingClass += " constant-header";
    if (parameter.PROCESS_TAG !== null) headingClass += " tag-header";
    return headingClass;
  }

  const firstKey = 1;
  const lastKey = parameterData && headings ? parameterData.length * headings.length : 0;
  
  // TODO - Try using 2D array for easier managment
  // Currently single dimensional array
  function handleKeyDown(e, key, rowWidth) {
    if (key !== lastKey && e.key === "Enter" && !e.ctrlKey)
      refList[(key += 1)].focus();

    if (!e.ctrlKey) return;

    if (e.key === "Enter") {
      handleSubmit();
    }

    if (key !== lastKey && e.key === "ArrowRight") refList[(key += 1)].focus();

    if (key !== firstKey && e.key === "ArrowLeft") refList[(key -= 1)].focus();

    if (e.key === "ArrowUp" && key > rowWidth)
      refList[(key -= rowWidth)].focus();

    if (e.key === "ArrowDown" && key < lastKey - rowWidth)
      refList[(key += rowWidth)].focus();

    // Ctrl + B copy down - Doesn't trigger change event
    // if (e.key === "b" && key > rowWidth)
    //   refList[key].value = refList[(key -= rowWidth)].value;
    // Home Key to start of Row
    // End Key to end of Row
    // Page Up to First Row
    // Page Down to Last Row
  }

  function handleKeyUp(rowIndex, columnIndex) {
    updateCCF(columnIndex);
  }

  function isDisabled(row) {
    // return false;

    const rowDate = moment(row.FTR_DATE).add(row.FTR_HOUR, "hours");
    // Campaign Start
    if (startDate.diff(rowDate, "days") >= 0) return true;
    // Campaign End
    if (endDate.diff(rowDate, "days") < -1) return true;

    // Historic Permission
    let rowRealDate = moment.utc(row.REAL_DATE);
    rowRealDate = rowRealDate.add(row.REAL_HOUR, "hours");
    if (!user.HISTORIC_DATA && moment().diff(rowRealDate, "days") > 3)
      return true;
    return false;
  }

  // Breaks Referencing
  // data = data.slice(24 - displayRows);

  function hasCCF(parameter) {
    return parameter.CCF !== undefined && parameter.CCF !== null && parameter.CCF !== '';
  }

  function isBlank(value) {
    return (value === null || value === undefined || value === '');
  }

  return (
    // <table className="table table-bordered table-data table-responsive table-sm">
    <div className="table-wrapper">
      <div className="table-scroller">
        <table
          className="table table-bordered table-sm table-data"
          style={fontSize === "sm" ? { fontSize: "0.75rem" } : {}}
        >
          <thead>
            <tr>
              <th className="text-nowrap sticky-col-1"></th>
              <th className="text-nowrap sticky-col-2"></th>
              {headings.map((parameter) => (
                <th
                  className={
                    parameter.SEPERATOR
                      ? "text-nowrap text-center seperator"
                      : "text-nowrap text-center"
                  }
                  key={parameter.CODE}
                >
                  {parameter.HEADING1}
                </th>
              ))}
            </tr>
            <tr>
              <th className="text-nowrap sticky-col-1">Date</th>
              <th className="text-nowrap sticky-col-2">Hour</th>
              {headings.map((parameter) => (
                <th
                  className={
                    parameter.SEPERATOR
                      ? "text-nowrap text-center seperator"
                      : "text-nowrap text-center"
                  }
                  key={parameter.CODE}
                >
                  {parameter.HEADING2}
                </th>
              ))}
            </tr>
            <tr>
              <th className="text-nowrap sticky-col-1"></th>
              <th className="text-nowrap sticky-col-2"></th>
              {headings.map((parameter) => (
                <th
                  className={
                    parameter.SEPERATOR
                      ? "text-nowrap text-center seperator"
                      : "text-nowrap text-center"
                  }
                  key={parameter.CODE}
                >
                  {parameter.HEADING3}
                </th>
              ))}
            </tr>
            <tr>
              <th className="text-nowrap sticky-col-1"></th>
              <th className="text-nowrap sticky-col-2"></th>
              {headings.map((parameter) => (
                <th
                  className={getParameterClass(parameter)}
                  key={parameter.CODE}
                >
                  {showCodes &&
                    (user.PARAMETERS ? (
                      <Link
                        to={`/parameters/${parameter.CODE}`}
                        className="de-parm-link"
                      >
                        {parameter.CODE}
                      </Link>
                    ) : (
                      parameter.CODE
                    ))}

                  <OverlayTrigger
                    trigger={["hover","focus"]}
                    placement={"auto"}
                    delay={{ hide: 500 }}
                    overlay={
                      hasCCF(parameter) ?
                      <Tooltip id={`tooltip-${parameter.CODE}`}>
                        Upper Absolute: {parameter.UPPER_ABSOLUTE}
                        <br />
                        Upper Check: {parameter.UPPER_CHECK}
                        <br />
                        Lower Check: {parameter.LOWER_CHECK}
                        <br />
                        Lower Absolute: {parameter.LOWER_ABSOLUTE}
                        <br />
                        CCF Upper Absolute: {parameter.HIGHABS}
                        <br />
                        CCF Upper Trigger: {parameter.HIGHTRG}
                        <br />
                        CCF Lower Trigger: {parameter.LOWTRG}
                        <br />
                        CCF Lower Absolute: {parameter.LOWABS}
                      </Tooltip>
                      :
                      <Tooltip id={`tooltip-${parameter.CODE}`}>
                        Upper Absolute: {parameter.UPPER_ABSOLUTE}
                        <br />
                        Upper Check: {parameter.UPPER_CHECK}
                        <br />
                        Lower Check: {parameter.LOWER_CHECK}
                        <br />
                        Lower Absolute: {parameter.LOWER_ABSOLUTE}
                      </Tooltip>
                    }
                  >
                    <i className="fas fa-info-circle ml-1 text-secondary"></i>
                  </OverlayTrigger>
                </th>
              ))}
            </tr>
            <tr>
              <th className="text-nowrap sticky-col-1"></th>
              <th className="text-nowrap sticky-col-2"></th>
              {headings.map((parameter) => (
                <th key={parameter.CODE}
                  className={
                    parameter.SEPERATOR
                      ? "text-nowrap text-center seperator"
                      : "text-nowrap text-center"
                  }
                >
                  {!isBlank(parameter.CCFLABEL)
                    ? parameter.CCFLABEL === 'Pending Close'
                      ? <div className="badge badge-primary">{parameter.CCFLABEL}</div>
                      : <div className="badge badge-warning">{parameter.CCFLABEL}</div>
                    : <div />
                  }
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {parameterData.map((row, i) => (
              <tr key={i}>
                <td
                  className="sticky-col-1"
                  style={fontSize === "sm" ? { padding: ".1rem" } : {}}
                >
                  {moment(row.REAL_DATE).format("DD-MMM-YY")}
                </td>
                <td
                  className="sticky-col-2"
                  style={fontSize === "sm" ? { padding: ".1rem" } : {}}
                >
                  {row.REAL_HOUR}
                </td>
                {headings.map((parameter, key2) => (
                  <td
                    key={key2}
                    className={getDataClass(parameter, row)}
                    style={fontSize === "sm" ? { padding: ".1rem" } : {}}
                  >
                    <input
                      type="text"
                      className="number-input"
                      style={
                        fontSize === "sm"
                          ? {
                              fontSize: "0.75rem",
                              height: "calc(1em + 0.3rem + 2px)",
                            }
                          : {}
                      }
                      id={parameter.CODE + '-' + i + '-' + key2}
                      onChange={(e) => handleChange(e, row, parameter, i)}
                      onKeyDown={(e) =>
                        handleKeyDown(
                          e,
                          i * headings.length + (key2 + 1),
                          headings.length
                        )
                      }
                      onKeyUp={(e) =>
                        handleKeyUp(i, key2)
                      }
                      value={
                        row[parameter.CODE] !== null ? row[parameter.CODE] : ""
                      }
                      ref={(ref) =>
                        (refList[i * headings.length + (key2 + 1)] = ref)
                      }
                      disabled={isDisabled(row)}
                      autoComplete="off"
                    ></input>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataEntryTable;
